<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <v-card flat>
            <div class="text-center mt-4">
            <v-chip
              v-for="(item, i) in regions"
              :key="i"
              class="ma-2"
              color="primary"
              >{{ item.ll_region }}</v-chip
            >
          </div>
          <v-card-actions>
            <v-container fluid>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-menu
                    v-model="menuStart"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedStart"
                        label="Début"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="start"
                      no-title
                      @input="menuStart = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="my-0 py-0">
                  <v-menu
                    v-model="menuEnd"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="computedEnd"
                        label="Fin"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requis"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="end"
                      no-title
                      @input="menuEnd = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    @change="buildrequest()"
                    v-model="projetSelected"
                    :items="projets"
                    outlined
                    dense
                    label="Projets"
                    item-text="ll_programme"
                    item-value="ll_programme"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    @change="buildrequest()"
                    v-model="activiteSelected"
                    :items="activitesFiltered"
                    outlined
                    dense
                    label="Activites"
                    item-text="ll_parcours"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="my-0 py-0">
                  <v-autocomplete
                    style="width: 390px;"
                    @change="buildrequest()"
                    v-model="animateurSelected"
                    :items="animateursDeProjets"
                    outlined
                    dense
                    label="Animateurs"
                    item-text="displayName"
                    item-value="id"
                    deletable-chips
                    small-chips
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-right my-0 py-0">
                  <v-btn
                    color="primary"
                    @click="
                      requestFormationDeMsasseDeRegions(regionSupervisees)
                    "
                    :loading="loading"
                  >
                    Afficher les formations de masse
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
          <v-card-text>
            <v-card flat>
              <v-card-text>
                <vue-excel-xlsx
                 v-if="formationsDeMasseDeRegion.length > 0"
                  :data="formationsDeMasseDeRegion"
                  :columns="columnFormationDeMasse"
                  :filename="'formationsDeMasse'"
                  :sheetname="'formationsDeMasse'"
                >
                  <v-btn class="primary">
                    <v-icon>mdi-microsoft-excel</v-icon> Télécharger les
                {{ formationsDeMasseDeRegion.length }} formations</v-btn
                  >
                </vue-excel-xlsx>
              </v-card-text>
              <v-card-text>
                <div>Femmes: {{ nombreFemmes }}</div>
                <div>Hommes: {{ nombreHommes }}</div>
           <!--      {{ query.sn.K }} -->
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Rechercher"
                  single-line
                  hide-details
                  class="mb-4"
                ></v-text-field>
                <v-data-table
                  :headers="columnFormationDeMasse"
                  :items="formationsDeMasseDeRegion"
                  :items-per-page="20"
                  class="elevation-1"
                  :search="search"
                  locale="fr"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-container style="width: 200px;" v-if="user.role=='regionalFull'">
                      <v-row no-gutters>
                        <v-col class="mx-1" style="flex-grow: 0;">
                          <v-btn class="mr-2" fab dark x-small color="warning">
                            <v-icon dark>
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                        </v-col>
                        <v-col class="mx-1" style="flex-grow: 0;">
                          <v-btn class="mr-2" fab dark x-small color="danger">
                            <v-icon dark>
                              mdi-trash-can
                            </v-icon>
                          </v-btn>
                        </v-col>
                        <v-col class="mx-1" style="flex-grow: 0;"
                          ><v-btn class="mx-0" fab dark x-small color="green">
                            <v-icon>
                              mdi-chevron-right
                            </v-icon>
                          </v-btn></v-col
                        >
                      </v-row>
                    </v-container>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  watch: {
    projetSelected: function (val) {
      let activitesFiltered = _.filter(this.activites, {
        ll_programme: val,
      });
      this.activitesFiltered = activitesFiltered;
    },
  },
  created() {
    this.SetProjectList();
    this.getDetailsRegionsSupervisees(this.listeRegionsSupervisees);
    this.getAnimateurs(this.regionSupervisees);
    this.getProjets();
    this.getActivites();
  },

  data() {
    return {
      ProjetctList: [],
      query: { sn: { K: {} } },
      menuStart: false,
      menuEnd: false,
      start: this.$moment(Date.now()).subtract(2, "years").format("YYYY-MM-DD"),
      end: this.$moment(Date.now()).format("YYYY-MM-DD"),
      menu2: false,
      request: { projets: null, animateurs: null, activites: null },
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      columnFormationDeMasse: [
        {
          text: "Formation",
          value: "ll_formation",
          label: "Formation",
          field: "ll_formation",
        },
        {
          text: "Date",
          value: "date_formation",
          label: "Date",
          field: "date_formation",
        },
        {
          text: "Animateur",
          value: "nom_responsable",
          label: "Animateur",
          field: "nom_responsable",
        },
        {
          text: "Bailleur",
          value: "abbr_bailleur",
          label: "Bailleur",
          field: "abbr_bailleur",
        },
        {
          text: "Projet",
          value: "ll_programme",
          label: "Projet",
          field: "ll_programme",
        },
        {
          text: "Activité",
          value: "ll_parcours",
          label: "Activité",
          field: "ll_parcours",
        },
        {
          text: "Femmes",
          value: "nombre_femmes_participants",
          label: "Femmes",
          field: "nombre_femmes_participants",
        },
        {
          text: "Hommes",
          value: "nombre_hommes_participants",
          label: "Hommes",
          field: "nombre_hommes_participants",
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
      search: "",
      projetSelected: null,
      animateurSelected: null,
      activiteSelected: null,
      activitesFiltered: [],
      loading: false,
      regions: [],
      formationSelected: { ll_formation: "", date_formation: "" },
      formationsDeMasseDeRegion: [],
    };
  },
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    ...mapActions({
      GetArrayRegions: "Utils/GetArrayRegions",
      getFormationsDeMassederegions:
        "FormationsDeMasse/getFormationsDeMassederegions",
      getAnimateurs: "Users/getAnimateurs",
      getActivites: "Activites/GetAll",
      getProjets: "Projets/getListeProjets",
    }),
    SetProjectList() {
      this.ProjetctList = Array.isArray(this.user.projets)
        ? this.user.projets.map((projet) => projet.id)
        : [];
    },
    buildrequest() {
      this.request.projets = this.projetSelected;
      this.request.animateurs = this.animateurSelected;
      this.request.activites = this.activiteSelected;
      console.log("request :", this.request);
    },
    getDetailsRegionsSupervisees(regionSupervisees) {
      let self = this;
      this.$firebase
        .firestore()
        .collection("regions")
        .where("id", "in", regionSupervisees)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.regions.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          console.log(self.regions);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },

    requestFormationDeMsasseDeRegions(arrayRegions) {
      let self = this;
      self.formationsDeMasseDeRegion = [];
      self.$vloading.show();

      var ref = this.$firebase.firestore().collection("formations");
      let query = ref
        .where("id_region", "in", arrayRegions)
        .where("date_formation", ">=", self.start)
        .where("date_formation", "<=", self.end);

      //Animateur
      console.log("Animateur :", this.request.animateurs);
      if (this.request.animateurs) {
        query = query.where(
          "users_id_user",
          "==",
          this.request.animateurs.toString()
        );
        console.log("Animateur :", this.request.animateurs);
      }
      //Activites
      if (this.request.activites) {
        console.log("activiteSelected : ", this.activiteSelected);
        query = query.where(
          "parcours_id_parcours",
          "==",
          this.request.activites.toString()
        );
      } else {
        //Projet
        if (this.request.projets) {
          query = query.where(
            "ll_programme",
            "==",
            this.request.projets.toString()
          );
          console.log("Projets :", this.request.projets);
        }
      }

      self.query = query.xd;
      //query final
      const results = query
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.formationsDeMasseDeRegion.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          //self.request = { projets: null, animateurs: null, activites: null };
          /*  self.projetSelected = null;
          self.animateurSelected = null;
          self.activiteSelected = null; */
          self.$vloading.hide();
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
  },
  computed: {
    computedDateFormation() {
      return this.formationSelected.date_dotation
        ? this.$moment(this.formationSelected.date_dotation).format(
            "DD-MM-YYYY"
          )
        : "";
    },
    computedStart() {
      return this.start ? this.start : "";
    },
    computedEnd() {
      return this.end ? this.end : "";
    },
    ...mapState({
      user: (state) => state.Auth.user,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      regionSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      //projets: (state) => state.Projets.projets,
      projets: (state) => state.Auth.user.projets,
      activites: (state) => state.Activites.Activites,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      animateursDeRegions: (state) => state.Users.animateursDeRegions,
      listeRegionsSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      animateursDeProjets(state) {
        return state.Users.animateursDeRegions.filter((u) => {
          const projets = Array.isArray(u.projets) ? u.projets : [];
          return projets.some((d) => _.includes(this.ProjetctList, d.id));
        });
      },
    }),

    nombreFemmes: function () {
      const result = Object.values(this.formationsDeMasseDeRegion).reduce(
        (r, { nombre_femmes_participants }) =>
          r + parseInt(nombre_femmes_participants),
        0
      );
      return result;
    },
    nombreHommes: function () {
      const result = Object.values(this.formationsDeMasseDeRegion).reduce(
        (r, { nombre_hommes_participants }) =>
          r + parseInt(nombre_hommes_participants),
        0
      );
      return result;
    },
  },
};
</script>

<style lang="scss" scoped></style>
